import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

export const ClaimGroupDiagnosticTreeSchema = Yup.object().shape({
  response: Yup.object().required(globalMessages.form.required),
});
